export default __webpack_public_path__ + "static/media/standoff.d794f9c6.jpg";